export const getPathResolver = (page: HeaderMenuPath, currentPath?: string): PathResolve => {
    if (!(page in paths)) {
        return {
            url: '/',
            current: false,
        };
    }
    // SSR時（`typeof window === 'undefined'`）はwindow.location.hrefを参照できないため、
    // 呼び出し元がrailsContext等から明示的に渡すcurrentPath（実際のリクエストパス）があれば
    // それを使ってCSR側と同じeq/matches判定を行う。渡されなければ従来通りfalseにフォールバックする
    // （currentPathを渡さない既存の呼び出し元の挙動は変えない）
    if (typeof window === 'undefined') {
        if (!currentPath) {
            return {
                url: paths[page].url,
                current: false,
            };
        }
        if (paths[page].eq) {
            const r = paths[page].eq.findIndex((p) => p === currentPath) > -1;
            return {
                url: paths[page].url,
                current: r,
            };
        }
        if (paths[page].matches) {
            const r = paths[page].matches.findIndex((p) => currentPath.includes(p)) > -1;
            return {
                url: paths[page].url,
                current: r,
            };
        }
        return {
            url: '/',
            current: false,
        };
    }
    const u = new URL(window.location.href);
    if (paths[page].eq) {
        const r = paths[page].eq.findIndex((p) => p === u.pathname) > -1;
        return {
            url: paths[page].url,
            current: r,
        };
    }
    if (paths[page].matches) {
        const r = paths[page].matches.findIndex((p) => u.pathname.includes(p)) > -1;
        return {
            url: paths[page].url,
            current: r,
        };
    }
    return {
        url: '/',
        current: false,
    };
};

export type HeaderMenuPath =
    | 'home'
    | 'search'
    | 'knowledge'
    | 'member_voice'
    | 'about_membership'
    | 'service'
    | 'club'
    | 'corporate'
    | 'course_interviews'
    | 'featured_staff_blog';
export interface PathResolve {
    url: string;
    current: boolean;
}

type PathSetting = {
    [key in HeaderMenuPath]: {
        matches?: string[];
        eq?: string[];
        url: string;
    };
};
const paths: PathSetting = {
    home: {
        url: '/',
        eq: ['/'],
    },
    search: {
        url: '/courses',
        matches: ['/search', '/courses'],
    },
    knowledge: {
        url: '/knowledge',
        matches: ['/knowledge'],
    },
    member_voice: {
        url: '/member_voices',
        matches: ['/member_voices'],
    },
    about_membership: {
        url: '/company/summary',
        matches: ['/company'],
    },
    service: {
        url: '/service',
        eq: ['/service'],
    },
    club: {
        url: '/club',
        eq: ['/club'],
    },
    corporate: {
        url: '/corporate',
        eq: ['/corporate', '/valuation'],
    },
    course_interviews: {
        url: '/course_interviews',
        matches: ['/course_interviews'],
    },
    featured_staff_blog: {
        url: '/info/featured_staff_blogs',
        matches: ['/info/featured_staff_blogs'],
    },
};
